/* ============================================================================
   PRESSROOM — FAQ akordeon davranisi (FAZ 2 Parti 3, spec 3.9)
   <pressroom-faq> web component.

   Taban: semantik <details>/<summary> — JS olmadan da acilir/kapanir (klavye
   + ekran okuyucu bedava). JS yalnizca GELISTIRME katmani: olculu-yukseklik
   gecisi (CLS yok), boylece panel "fast/e-out" ile yumusak acilir.

   Teknik: native toggle'i geciktirip yukseligi 0<->scrollHeight arasi anime
   ederiz. Acik kalsin diye `open` attribute korunur; kapanista transitionend
   sonunda kaldirilir.

   reduced-motion: HICBIR gelistirme kurulmaz — saf native details (aninda
   ac/kapa). data-pr-anim eklenmez, CSS height gecisi devreye girmez.

   Hardcoded yok: gecis suresi --d-fast token'dan okunur (CSS yonetir; JS yalniz
   transitionend bekler, sayisal sure tutmaz).
   ============================================================================ */
(function () {
  'use strict';

  if (!('customElements' in window)) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  customElements.define('pressroom-faq', class extends HTMLElement {
    connectedCallback() {
      this._items = Array.prototype.slice.call(this.querySelectorAll('[data-pr-faq-item]'));
      if (!this._items.length) return;

      // reduced-motion: native details yeterli; gelistirme yok.
      if (REDUCED) return;

      // Gelistirme devrede isareti -> CSS height gecisini aktive eder.
      this.setAttribute('data-pr-anim', '');

      this._onSummaryClick = this._onSummaryClick.bind(this);
      this._items.forEach(function (item) {
        var summary = item.querySelector('[data-pr-faq-summary]');
        var panel = item.querySelector('[data-pr-faq-panel]');
        if (!summary || !panel) return;

        // Acik baslayan item: yuksekligi olc, custom property'ye yaz.
        if (item.hasAttribute('open')) {
          panel.style.setProperty('--pr-faq-h', panel.scrollHeight + 'px');
        }
        summary.addEventListener('click', this._onSummaryClick);
      }, this);
    }

    disconnectedCallback() {
      if (!this._items) return;
      this._items.forEach(function (item) {
        var summary = item.querySelector('[data-pr-faq-summary]');
        if (summary) summary.removeEventListener('click', this._onSummaryClick);
      });
    }

    _onSummaryClick(e) {
      var summary = e.currentTarget;
      var item = summary.closest('[data-pr-faq-item]');
      var panel = item ? item.querySelector('[data-pr-faq-panel]') : null;
      if (!item || !panel) return;

      // Native toggle'i biz yonetelim ki yukseklik animasyonu gorunsun.
      e.preventDefault();

      if (item.hasAttribute('open')) {
        this._collapse(item, panel);
      } else {
        this._expand(item, panel);
      }
    }

    _expand(item, panel) {
      item.setAttribute('open', '');
      // 0'dan olculu yukseklige: scrollHeight'i custom property'ye yaz.
      var target = panel.scrollHeight;
      panel.style.setProperty('--pr-faq-h', target + 'px');
      // CSS: [open] .panel height = var(--pr-faq-h). Reflow tetikle.
      void panel.offsetHeight;
    }

    _collapse(item, panel) {
      // Acik yuksekligi sabitle, sonra 0'a animasyonla in; bitince open kaldir.
      var current = panel.scrollHeight;
      panel.style.setProperty('--pr-faq-h', current + 'px');
      void panel.offsetHeight;

      var onEnd = function (ev) {
        if (ev && ev.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', onEnd);
        item.removeAttribute('open');
      };
      panel.addEventListener('transitionend', onEnd);

      // open hala duruyorken yuksekligi 0'a cek -> CSS [open] kuralini
      // gecici olarak ezmek icin inline 0 set et; transition height'i indirir.
      requestAnimationFrame(function () {
        panel.style.setProperty('--pr-faq-h', '0px');
      });
    }
  });
})();
